import Footer from '../../components/layout/Footer';
import Icon from '../../components/AppIcon';

const FooterComponent = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex flex-col">
      {/* Demo Section */}
      <div className="flex-1 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-foreground mb-4">
            مكون الفوتر
          </h1>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            فوتر شامل يحتوي على معلومات الشركة، روابط سريعة، معلومات الاتصال، ووسائل التواصل الاجتماعي
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          <div className="bg-white rounded-xl p-6 border border-border shadow-sm">
            <div className="flex items-center gap-3 mb-4">
              <div className="flex items-center justify-center w-12 h-12 rounded-lg bg-primary/10">
                <Icon name="Building2" size={24} color="var(--color-primary)" />
              </div>
              <h3 className="text-lg font-semibold">معلومات الشركة</h3>
            </div>
            <p className="text-sm text-muted-foreground">
              شعار الشركة ووصف شامل عن خدمات المنصة
            </p>
          </div>

          <div className="bg-white rounded-xl p-6 border border-border shadow-sm">
            <div className="flex items-center gap-3 mb-4">
              <div className="flex items-center justify-center w-12 h-12 rounded-lg bg-secondary/10">
                <Icon name="Link" size={24} color="var(--color-secondary)" />
              </div>
              <h3 className="text-lg font-semibold">روابط سريعة</h3>
            </div>
            <p className="text-sm text-muted-foreground">
              روابط للصفحات الهامة مثل من نحن والشروط والأحكام
            </p>
          </div>

          <div className="bg-white rounded-xl p-6 border border-border shadow-sm">
            <div className="flex items-center gap-3 mb-4">
              <div className="flex items-center justify-center w-12 h-12 rounded-lg bg-accent/10">
                <Icon name="Phone" size={24} color="var(--color-accent)" />
              </div>
              <h3 className="text-lg font-semibold">معلومات الاتصال</h3>
            </div>
            <p className="text-sm text-muted-foreground">
              أرقام الهاتف والبريد الإلكتروني والعنوان
            </p>
          </div>

          <div className="bg-white rounded-xl p-6 border border-border shadow-sm">
            <div className="flex items-center gap-3 mb-4">
              <div className="flex items-center justify-center w-12 h-12 rounded-lg bg-success/10">
                <Icon name="Share2" size={24} color="var(--color-success)" />
              </div>
              <h3 className="text-lg font-semibold">وسائل التواصل</h3>
            </div>
            <p className="text-sm text-muted-foreground">
              روابط لحسابات التواصل الاجتماعي (Instagram, Twitter, LinkedIn)
            </p>
          </div>
        </div>

        {/* Footer Sections Preview */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Links Section */}
          <div className="bg-white rounded-xl p-6 border border-border shadow-sm">
            <h3 className="text-xl font-semibold mb-4 flex items-center gap-2">
              <Icon name="List" size={24} color="var(--color-primary)" />
              أقسام الفوتر
            </h3>
            <div className="grid grid-cols-2 gap-6">
              <div>
                <h4 className="font-semibold text-sm mb-3">الشركة</h4>
                <ul className="space-y-2 text-sm text-muted-foreground">
                  <li>من نحن</li>
                  <li>الشروط والأحكام</li>
                  <li>سياسة الخصوصية</li>
                  <li>اتصل بنا</li>
                </ul>
              </div>
              <div>
                <h4 className="font-semibold text-sm mb-3">الخدمات</h4>
                <ul className="space-y-2 text-sm text-muted-foreground">
                  <li>تصفح المصورين</li>
                  <li>احجز الآن</li>
                  <li>إنضم كمصور</li>
                  <li>مركز المساعدة</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Trust & Security */}
          <div className="bg-white rounded-xl p-6 border border-border shadow-sm">
            <h3 className="text-xl font-semibold mb-4 flex items-center gap-2">
              <Icon name="Shield" size={24} color="var(--color-success)" />
              الثقة والأمان
            </h3>
            <div className="space-y-4">
              <div className="flex items-center gap-3">
                <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-success/10">
                  <Icon name="Shield" size={20} color="var(--color-success)" />
                </div>
                <div>
                  <p className="font-semibold text-sm">دفع آمن</p>
                  <p className="text-xs text-muted-foreground">معاملات مشفرة ومحمية</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-success/10">
                  <Icon name="CheckCircle" size={20} color="var(--color-success)" />
                </div>
                <div>
                  <p className="font-semibold text-sm">موثوق</p>
                  <p className="text-xs text-muted-foreground">مصورون معتمدون ومراجعات حقيقية</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-primary/10">
                  <Icon name="CreditCard" size={20} color="var(--color-primary)" />
                </div>
                <div>
                  <p className="font-semibold text-sm">طرق دفع متعددة</p>
                  <p className="text-xs text-muted-foreground">بطاقات ائتمانية ومحافظ رقمية</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Social Media Preview */}
        <div className="mt-6 bg-white rounded-xl p-6 border border-border shadow-sm">
          <h3 className="text-xl font-semibold mb-4 flex items-center gap-2">
            <Icon name="Share2" size={24} color="var(--color-accent)" />
            تابعنا على وسائل التواصل الاجتماعي
          </h3>
          <div className="flex items-center gap-4">
            <a href="#" className="flex items-center justify-center w-12 h-12 rounded-lg bg-gradient-to-br from-blue-500 to-blue-600 text-white hover:scale-110 transition-transform">
              <Icon name="Instagram" size={24} />
            </a>
            <a href="#" className="flex items-center justify-center w-12 h-12 rounded-lg bg-gradient-to-br from-blue-400 to-blue-600 text-white hover:scale-110 transition-transform">
              <Icon name="Twitter" size={24} />
            </a>
            <a href="#" className="flex items-center justify-center w-12 h-12 rounded-lg bg-gradient-to-br from-blue-600 to-blue-800 text-white hover:scale-110 transition-transform">
              <Icon name="Linkedin" size={24} />
            </a>
            <a href="#" className="flex items-center justify-center w-12 h-12 rounded-lg bg-gradient-to-br from-blue-500 to-blue-700 text-white hover:scale-110 transition-transform">
              <Icon name="Facebook" size={24} />
            </a>
          </div>
        </div>
      </div>

      {/* Actual Footer Component */}
      <Footer />
    </div>
  );
};

export default FooterComponent;